import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import screenfull from 'screenfull';
import {toast} from 'react-toastify';
import {fullscreenSelector} from '../store/selectors/layout.selectors';
import {setFullscreenAction} from '../store/actions/layout.actions';

export const useFullscreen = (presContainerRef: React.RefObject<HTMLDivElement>): {isFullscreen: boolean; toggleFullscreen: () => void} => {
    const dispatch = useDispatch();
    const isFullscreen = useSelector(fullscreenSelector);

    const toggleFullscreen = (): void => {
        const newFullscreenView = !isFullscreen;
        dispatch(setFullscreenAction(newFullscreenView));

        if (presContainerRef && !presContainerRef.current) return;

        // logika za fullscreen i rotiranje ekrana na kojima je to dozvoljeno
        if (screenfull.isFullscreen) {
            screenfull
                .exit()
                .then(() => {
                    dispatch(setFullscreenAction(false));
                })
                .catch((err) => {
                    toast.error(`An error occurred while trying to exit fullscreen mode: ${err.message} (${err.name})`, {
                        toastId: 'fullscreen-exit-error',
                    });
                });
        } else if (presContainerRef?.current) {
            screenfull
                .request(document.body)
                .then(() => {
                    dispatch(setFullscreenAction(true));
                })
                .catch((err) => {
                    toast.error(`An error occurred while trying to switch into fullscreen mode: ${err.message} (${err.name})`, {
                        toastId: 'fullscreen-switch-error',
                    });
                });
        }
    };

    useEffect(() => {
        const handleFullscreenChange = (): void => {
            dispatch(setFullscreenAction(screenfull.isFullscreen));
        };

        document.addEventListener('fullscreenchange', handleFullscreenChange);

        return () => {
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
        };
    }, [dispatch]);

    return {isFullscreen, toggleFullscreen};
};
